export default class {
    constructor ($state, lodash, AUDITLOG_ENUM) {
        this.$state = $state;
        this.lodash = lodash;
        this.AUDITLOG_ENUM = AUDITLOG_ENUM;
    }

    buildLinks (items) {
        this.lodash.forEach(items, (item) => {
            item.link = this.getLink(item);
        });
    }

    getLink (item) {
        const events = this.AUDITLOG_ENUM.KEYS;
        let route = false;
        switch (item.action) {
        case events.afterInsertSite:
        case events.afterUpdateSite:
            route = 'authorized.manage.permissions.sites.detail';
            break;
        case events.afterDeleteSite:
            route = 'authorized.manage.permissions.sites.list';
            break;
        case events.afterInsertUserAssignment:
        case events.afterDeleteUserAssignment:
            route = 'authorized.manage.permissions.users.detail.sites';
            break;
        case events.afterInsertRole:
        case events.afterUpdateRole:
            route = 'authorized.manage.permissions.roles.detail.privileges';
            break;
        case events.afterDeleteRole:
            route = 'authorized.manage.permissions.roles.list';
            break;
        case events.afterInsertCompanySsoSetting:
        case events.afterUpdateCompanySsoSetting:
        case events.afterEnableCompanySsoSetting:
        case events.afterDisableCompanySsoSetting:
        case events.afterParseMetadataCompanySsoSetting:
            route = 'authorized.manage.settings.integration';
            break;
        case events.afterInsertCourse:
        case events.afterUpdateCourse:
            route = 'authorized.courses.courses.edit.general';
            break;
        case events.afterInsertCourseI18n:
        case events.afterUpdateCourseI18n:
        case events.afterDeleteCourseI18n:
            route = 'authorized.courses.courses.edit.general';
            break;
        case events.afterInsertCourseTraining:
        case events.afterUpdateCourseTraining:
        case events.afterDeleteCourseTraining:
        case events.afterInsertCourseTrainingI18n:
        case events.afterUpdateCourseTrainingI18n:
        case events.afterDeleteCourseTrainingI18n:
        case events.afterInsertCourseTrainingMaterialChapter:
        case events.afterUpdateCourseTrainingMaterialChapter:
            route = 'authorized.courses.courses.edit.version.edit.training';
            break;
        case events.afterInsertCourseUserDeadline:
        case events.afterUpdateCourseUserDeadline:
        case events.afterDeleteCourseUserDeadline:
            route = 'authorized.planning.needs';
            break;
        case events.afterInsertCourseVersion:
        case events.afterUpdateCourseVersion:
            route = 'authorized.courses.courses.edit.version.edit.general';
            break;
        case events.afterInsertCourseSkill:
        case events.afterUpdateCourseSkill:
        case events.afterDeleteCourseSkill:
            route = 'authorized.courses.courses.edit.version.edit.training';
            item.linkParams.tab = 'skills';
            break;
        case events.afterInsertCourseTarget:
        case events.afterUpdateCourseTarget:
        case events.afterDeleteCourseTarget:
        case events.afterInsertCourseTargetException:
        case events.afterUpdateCourseTargetException:
        case events.afterDeleteCourseTargetException:
            route = 'authorized.courses.courses.edit.target';
            break;
        case events.afterInsertCourseOccurrence:
        case events.afterUpdateCourseOccurrence:
        case events.afterInsertHistoricOccurrence:
            route = 'authorized.courses.courses.edit.occurrence.edit.general';
            break;
        case events.afterInsertCourseOccurrenceParticipant:
        case events.afterDeleteCourseOccurrenceParticipant:
            route = 'authorized.courses.courses.edit.occurrence.edit.employee';
            break;
        case events.afterCancelCourseOccurrence:
        case events.afterPublishCourseOccurrence:
        case events.afterInsertCourseOccurrenceTestTrainingFeedbackDeadline:
        case events.afterUpdateCourseOccurrenceTestTrainingFeedbackDeadline:
        case events.afterDeleteCourseOccurrenceTestTrainingFeedbackDeadline:
        case events.afterInsertCourseOccurrenceTrainingTime:
        case events.afterUpdateCourseOccurrenceTrainingTime:
        case events.afterDeleteCourseOccurrenceTrainingTime:
        case events.afterInsertCourseOccurrenceOnlineTrainingDeadline:
        case events.afterUpdateCourseOccurrenceOnlineTrainingDeadline:
        case events.afterDeleteCourseOccurrenceOnlineTrainingDeadline:
        case events.afterInsertCourseOccurrenceTrainingTimeParticipant:
        case events.afterDeleteCourseOccurrenceTrainingTimeParticipant:
        case events.afterInsertCourseOccurrenceTrainingTimeParticipantIsParticipated:
        case events.afterDeleteCourseOccurrenceTrainingTimeParticipantIsParticipated:
        case events.afterInsertCourseOccurrenceTrainingTimeParticipantSignature:
        case events.afterDeleteCourseOccurrenceTrainingTimeParticipantSignature:
        case events.afterInsertCourseOccurrenceTrainingTimeReportConfirmed:
            route = 'authorized.courses.courses.edit.occurrence.edit.schedule';
            break;
        case events.afterInsertUser:
        case events.afterUpdateUser:
        case events.afterUserAnonymized:
        case events.afterUserDeanonymized:
            route = 'authorized.user.employee.detail';
            break;
        case events.afterDeleteUser:
            route = 'authorized.user.employee.list';
            break;
        case events.afterInsertUserDrl:
        case events.afterUpdateUserDrl:
        case events.afterDeleteUserDrl:
        case events.afterInsertUserInactivityPeriod:
        case events.afterUpdateUserInactivityPeriod:
        case events.afterInsertUserSkill:
        case events.afterUpdateUserSkill:
        case events.afterDeleteUserSkill:
            route = 'authorized.user.employee.detail';
            break;
        case events.afterInsertForm:
        case events.afterUpdateForm:
        case events.afterInsertFormI18n:
        case events.afterUpdateFormI18n:
        case events.afterDeleteFormI18n:
            route = 'authorized.forms.forms.form';
            break;
        case events.afterDeleteForm:
            route = 'authorized.forms.forms.list';
            break;
        case events.afterInsertFormCategory:
        case events.afterUpdateFormCategory:
        case events.afterInsertFormCategoryI18n:
        case events.afterUpdateFormCategoryI18n:
        case events.afterDeleteFormCategoryI18n:
            route = 'authorized.forms.settings.formcategories.edit';
            break;
        case events.afterDeleteFormCategory:
            route = 'authorized.forms.settings.formcategories.list';
            break;
        case events.afterInsertQuestion:
        case events.afterUpdateQuestion:
            route = 'authorized.forms.questions.all.question';
            break;
        case events.afterDeleteQuestion:
            route = 'authorized.forms.questions.all.list';
            break;
        case events.afterInsertQuestionAnswer:
        case events.afterUpdateQuestionAnswer:
        case events.afterDeleteQuestionAnswer:
        case events.afterInsertQuestionI18n:
        case events.afterUpdateQuestionI18n:
        case events.afterDeleteQuestionI18n:
        case events.afterInsertQuestionMeta:
        case events.afterUpdateQuestionMeta:
        case events.afterDeleteQuestionMeta:
        case events.afterInsertQuestionMetaGroup:
        case events.afterDeleteQuestionMetaGroup:
            route = 'authorized.forms.questions.all.question';
            break;
        case events.afterInsertQuestionCategory:
        case events.afterUpdateQuestionCategory:
            route = 'authorized.forms.settings.questioncategories.edit';
            break;
        case events.afterDeleteQuestionCategory:
            route = 'authorized.forms.settings.questioncategories.list';
            break;
        case events.afterInsertMetaFieldGroup:
        case events.afterUpdateMetaFieldGroup:
        case events.afterDeleteMetaFieldGroup:
        case events.afterInsertMetaFieldGroupI18n:
        case events.afterUpdateMetaFieldGroupI18n:
        case events.afterDeleteMetaFieldGroupI18n:
            route = 'authorized.forms.settings.meta.list';
            break;
        case events.afterInsertQuestionPool:
        case events.afterUpdateQuestionPool:
        case events.afterInsertQuestionPoolI18n:
        case events.afterUpdateQuestionPoolI18n:
        case events.afterDeleteQuestionPoolI18n:
            route = 'authorized.forms.settings.pool.edit';
            break;
        case events.afterDeleteQuestionPool:
            route = 'authorized.forms.settings.pool.list';
            break;
        case events.afterInsertFormQuestion:
        case events.afterDeleteFormQuestion:
            route = 'authorized.forms.forms.form.questions';
            break;
        case events.afterInsertPlanningGroup:
        case events.afterUpdatePlanningGroup:
        case events.afterInsertPlanningGroupUser:
        case events.afterDeletePlanningGroupUser:
        case events.eventPlannedGroupStart:
        case events.eventPlannedGroupStop:
        case events.eventPlannedGroupCancel:
            route = 'authorized.courses.courses.edit.occurrence.automated.edit.general';
            break;
        case events.afterArchive:
        case events.afterReactivate:
            route = 'authorized.courses.courses.edit.general';
            break;
        case events.afterInsertLicence:
        case events.afterUpdateLicence:
            route = 'authorized.manage.settings.licences.detail';
            break;
        case events.afterInsertLicencePeriod:
        case events.afterUpdateLicencePeriod:
        case events.afterDeleteLicencePeriod:
            route = 'authorized.manage.settings.licences.detail';
            break;
        case events.afterInsertLicenceDrl:
        case events.afterUpdateLicenceDrl:
        case events.afterDeleteLicenceDrl:
            route = 'authorized.manage.settings.licences.detail';
            break;
        case events.afterInsertUserLicencePoint:
        case events.afterUpdateUserLicencePoint:
        case events.afterDeleteUserLicencePoint:
            route = 'authorized.user.employee.detail';
            break;
        case events.afterInsertCourseVersionLicence:
        case events.afterUpdateCourseVersionLicence:
        case events.afterDeleteCourseVersionLicence:
            route = 'authorized.courses.courses.edit.version.edit.licence';
            break;
        case events.afterModifyEmailSubject:
        case events.afterModifyEmailBody:
            route = 'authorized.manage.settings.templates.detail';
            break;
        case events.afterStatusDeclined:
        case events.afterStatusConfirmed:
        case events.afterParticipationUpdated:
        case events.afterCreatedByEmployee:
        case events.afterCancelledByEmployee:
        case events.afterEditedByEmployee:
        case events.afterStatusApprovedByDm:
        case events.afterStatusDeclinedByDm:
        case events.afterRequestSentBackForDetailsByDm:
            route = 'authorized.courses.participations.detail';
            break;
        case events.afterParticipationDeleted:
            route = 'authorized.courses.participations.list';
            break;
        case events.afterInsertTasklistTemplate:
        case events.afterUpdateTasklistTemplate:
        case events.tasklistTemplateTaskUpdated:
            route = 'authorized.manage.settings.tasklist.templates.edit';
            break;
        case events.taskListUserAssigned:
        case events.taskListCompleted:
        case events.taskListUpdated:
        case events.taskListTaskCompleted:
        case events.taskListTaskIncompleted:
        case events.taskListTaskUpdated:
            route = 'authorized.user.tasklist.edit';
            break;
        case events.applicationDeclinedEvent:
        case events.applicationApprovedEvent:
            route = 'authorized.courses.application.detail';
            break;
        case events.afterValidateTestQuestion:
        case events.courseOccurrenceTrainingProgressMarkAsNotPassed:
            route = 'authorized.forms.validations.detail';
            break;
        case events.afterInsertSkill:
        case events.afterUpdateSkill:
        case events.afterInsertSkillI18n:
        case events.afterUpdateSkillI18n:
            route = 'authorized.user.skill.edit.skill';
            break;
        case events.afterDeleteSkill:
        case events.afterDeleteSkillI18n:
            route = 'authorized.user.skill.list.skill';
            break;
        case events.afterInsertSkillScale:
        case events.afterUpdateSkillScale:
        case events.afterInsertSkillScaleI18n:
        case events.afterUpdateSkillScaleI18n:
            route = 'authorized.user.skill.list.scale';
            break;
        case events.afterDeleteSkillScale:
        case events.afterDeleteSkillScaleI18n:
            route = 'authorized.user.skill.list.scale';
            break;
        default:
            break;
        }

        // check for undefined for backwards compatibility
        if (route === false || item.linkParams === null) {
            return '';
        }
        return this.$state.href(route, item.linkParams, { absolute: true });
    }
}



// WEBPACK FOOTER //
// ./src/app/services/audit/log/index.js